import * as React from 'react';
import styled from 'styled-components';

import { is, themeGet, Card } from '@packages/ui';
import { ClickoutProps, WishlistHelper } from '@packages/common';

import { productTileBottomHeight } from './utils/HeightCalculator';
import { ProductTileTop } from '../ProductTile';
import { RecoTileBottom } from './recoTileBottom';

const CardStyled = styled(Card)<{ highlight: boolean }>`
  overflow: hidden;
  width: 100%;

  ${is('highlight')`
    outline: ${themeGet.space(1)} solid ${themeGet.colors('swirl')};
  `}
`;

// TODO: extend ProductTileProps
interface RecoTileProps extends ClickoutProps {
  Clickout: React.FC<ClickoutProps>;
  wishlistHelper: WishlistHelper;
  highlight?: boolean;
}

export const RecoTile: React.FC<RecoTileProps> = ({
  product,
  wishlistHelper,
  Clickout,
  area,
  index,
  highlight = false,
  trackingToken = '',
}) => {
  return (
    <CardStyled highlight={highlight}>
      <Clickout sorted={false} product={product} index={index} area={area} trackingToken={trackingToken}>
        <ProductTileTop
          wishlistHelper={wishlistHelper}
          product={product}
          isSlider={true}
          hidePromotionsOnXS={false}
          sorted={false}
          index={index}
        ></ProductTileTop>
      </Clickout>
      <Clickout sorted={false} product={product} index={index} area={area} trackingToken={trackingToken}>
        <RecoTileBottom product={product} height={productTileBottomHeight} />
      </Clickout>
    </CardStyled>
  );
};
